import { Outlet, createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { OrgSidebar } from '@/features/OrgLayout/OrgSidebar';
import { OrgTopBar } from '@/features/OrgLayout/OrgTopBar';

export const Route = createFileRoute('/org')({
  component: OrgLayout,
});

function OrgLayout() {
  const { user } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role !== 'org_admin' && user.role !== 'super_admin') {
      navigate({ to: '/dashboard' });
    }
  }, [user, navigate]);

  if (!user || (user.role !== 'org_admin' && user.role !== 'super_admin')) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        Access restricted to organization admins.
      </div>
    );
  }

  return (
    <div className="org-root flex h-screen overflow-hidden">
      <OrgSidebar />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <OrgTopBar />
        {/* Same gradient shell as the student panel, for cross-portal consistency. */}
        <main
          className="flex-1 overflow-y-auto px-8 py-7"
          style={{
            backgroundImage: [
              'radial-gradient(circle, rgba(26,23,20,0.12) 1px, transparent 1px)',
              'radial-gradient(ellipse 900px 700px at top right, rgba(232, 102, 13, 0.18) 0%, transparent 65%)',
              'radial-gradient(ellipse 500px 400px at 5% 95%, rgba(124, 58, 237, 0.10) 0%, transparent 55%)',
            ].join(', '),
            backgroundSize: '22px 22px, auto, auto',
            backgroundColor: '#faf8f6',
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
